/* ==========================================================================
   LP "Se liga! Coffee ON" — motor de revelação por scroll.

   Cada elemento [data-sl-scene] recebe a custom property --p (0 -> 1) conforme
   a seção atravessa a viewport. As camadas fazem o resto só com CSS (calc()
   multiplicando os deltas de cada folha/sachê por --p).

   O progresso é ancorado num PONTO DE FOCO da cena — o assunto que precisa
   estar à vista enquanto a animação acontece (as latas, os sachês). Ancorar
   no topo da seção não funciona: a arte é mais alta que a tela, então a
   animação terminava antes de o produto aparecer.

     focus = rect.top + f * rect.height          (y do assunto na viewport)
     p     = (from*vh - focus) / ((from - to) * vh)

   Atributos aceitos na cena:
     data-sl-focus  onde está o assunto, como fração da altura da cena
                    (0.6 = 60% abaixo do topo da cena). Padrão: 0.5
     data-sl-from   posição do assunto, em frações da altura da tela, onde a
                    animação COMEÇA. 1.2 = um pouco abaixo da borda de baixo.
     data-sl-to     idem, onde a animação TERMINA. 0.5 = no meio da tela.
     data-sl-from-mobile / data-sl-to-mobile
                    mesmos papéis, usados em telas estreitas (<=749px), onde a
                    arte é bem mais baixa em relação à tela e a janela de
                    scroll precisa ser esticada.

   Linha de base: em telas baixas (mobile) a seção pode já estar meio visível
   quando a página abre — nesse caso a animação começaria pela metade. Se o
   carregamento acontece no topo da página, guardamos o progresso "bruto"
   inicial e remapeamos para que a cena sempre comece em 0.

   Bidirecional: --p acompanha o scroll nos dois sentidos. Descer revela,
   subir refaz — o efeito pode rodar quantas vezes o visitante quiser.
   ========================================================================== */
(function () {
  'use strict';

  // O snippet lp-seliga-head é renderizado por TODAS as seções lp-seliga-*, e a
  // LP tem 8 delas — ou seja, esta tag <script> aparece 8x na página. O browser
  // deduplica a REDE (mesma URL = 1 fetch), nunca a EXECUÇÃO: cada elemento
  // <script src> roda o arquivo. Sem esta trava a página subia 8 motores, com 8
  // listeners de scroll, 8 rAF e 8 update() por frame.
  if (window.__slEngineBooted) return;
  window.__slEngineBooted = true;

  var scenes = [];
  var marquees = [];
  var sceneIO = null;
  var marqueeIO = null;
  var ativas = 0;
  var ticking = false;
  var baseStore = {};
  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function collect() {
    scenes = Array.prototype.slice.call(document.querySelectorAll('[data-sl-scene]'));
    marquees = Array.prototype.slice.call(document.querySelectorAll('.sl-marquee'));
    observe();
  }

  // Observadores em vez de medir tudo a cada frame:
  //  - cena: só ganha will-change (e entra no loop) quando está por perto E ainda
  //    não terminou. As camadas são imagens grandes; mantê-las promovidas o tempo
  //    todo gasta memória de textura à toa.
  //  - marquee: a animação é de transform num trilho de ~5,7 mil px. Fora da tela
  //    ela não precisa rodar.
  function observe() {
    if (!window.IntersectionObserver) return;

    if (sceneIO) sceneIO.disconnect();
    ativas = 0;
    sceneIO = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var el = entries[i].target;
          var antes = el.__slNear === true;
          el.__slNear = entries[i].isIntersecting;
          if (antes !== el.__slNear) ativas += el.__slNear ? 1 : -1;
          setActive(el, entries[i].isIntersecting);
        }
        onScroll();
      },
      { rootMargin: '100% 0px' }
    );
    for (var i = 0; i < scenes.length; i++) sceneIO.observe(scenes[i]);

    if (marqueeIO) marqueeIO.disconnect();
    marqueeIO = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j++) {
          entries[j].target.classList.toggle('is-paused', !entries[j].isIntersecting);
        }
      },
      { rootMargin: '20% 0px' }
    );
    for (var k = 0; k < marquees.length; k++) marqueeIO.observe(marquees[k]);
  }

  function setActive(el, on) {
    el.classList.toggle('is-active', !!on);
  }

  // smoothstep: tira o "liga/desliga" das pontas sem descolar do scroll
  function ease(t) {
    return t * t * (3 - 2 * t);
  }

  function clamp01(v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
  }

  function attr(el, name, fallback) {
    var v = parseFloat(el.getAttribute(name));
    return isNaN(v) ? fallback : v;
  }

  function atTop() {
    return (window.pageYOffset || document.documentElement.scrollTop) < 100;
  }

  function currentP(el) {
    var v = parseFloat(el.style.getPropertyValue('--p'));
    return isNaN(v) ? 0 : v;
  }

  // id do wrapper da seção: sobrevive ao re-render do editor de temas, ao
  // contrário do elemento da cena (que é substituído por um nó novo)
  function sceneKey(el) {
    var host = el.closest ? el.closest('[id^="shopify-section-"]') : null;
    return host ? host.id : null;
  }

  // Os ranges do editor se sobrepõem, então dá para gravar from <= to. O menor
  // dos dois é sempre o ponto de CHEGADA (é ele que define o enquadramento do
  // produto); e a janela nunca pode ficar abaixo de 0,25 da altura da tela,
  // senão o efeito inteiro cabe numa chanfrada de roda de mouse.
  function normaliza(from, to) {
    if (from < to) {
      var swap = from;
      from = to;
      to = swap;
    }
    if (from - to < 0.25) from = to + 0.25;
    return [from, to];
  }

  // Os data-sl-* só mudam quando a seção é re-renderizada — e aí o elemento é
  // outro. Ler e normalizar uma vez tira getAttribute, parseFloat e closest()
  // do laço que roda a cada frame.
  function cfg(el) {
    if (el.__slCfg) return el.__slCfg;

    var from = attr(el, 'data-sl-from', 1.2);
    var to = attr(el, 'data-sl-to', 0.5);
    var d = normaliza(from, to);
    var m = normaliza(attr(el, 'data-sl-from-mobile', from), attr(el, 'data-sl-to-mobile', to));

    el.__slCfg = {
      f: attr(el, 'data-sl-focus', 0.5),
      from: d[0], to: d[1],
      fromM: m[0], toM: m[1],
      key: sceneKey(el),
    };
    return el.__slCfg;
  }

  function rawProgress(el, rect, vh, narrow) {
    var c = cfg(el);
    var from = narrow ? c.fromM : c.from;
    var to = narrow ? c.toM : c.to;

    var focus = rect.top + c.f * rect.height;
    return clamp01((from * vh - focus) / ((from - to) * vh));
  }

  // onlyIdle = só re-ancora cenas que ainda não começaram a animar. Serve para o
  // resize: reancorar no meio da animação faria --p despencar para 0 num frame.
  function setBaselines(onlyIdle) {
    var vh = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < scenes.length; i++) {
      var el = scenes[i];
      if (onlyIdle && currentP(el) > 0.001) continue;

      var raw = rawProgress(el, el.getBoundingClientRect(), vh, isNarrow());
      // se a cena já passou quase inteira (reload no meio da página) não remapeia
      var base = raw < 0.9 ? raw : 0;

      el.__slBase = base;
      var key = cfg(el).key;
      if (key) baseStore[key] = base;
    }
  }

  // depois do re-render do editor as expandos morreram junto com o nó antigo
  function restoreBaselines() {
    for (var i = 0; i < scenes.length; i++) {
      var el = scenes[i];
      if (el.__slBase != null) continue;

      var key = cfg(el).key;
      var saved = key ? baseStore[key] : null;
      if (saved == null) continue;

      el.__slBase = saved;
    }
  }

  function isNarrow() {
    return (window.innerWidth || document.documentElement.clientWidth) <= 749;
  }

  function setP(el, v) {
    // reescrever o mesmo valor invalida estilo à toa
    if (el.__slP === v) return;
    el.__slP = v;
    el.style.setProperty('--p', v);
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var narrow = isNarrow();
    var i;

    // Fase 1 — só LEITURA. Intercalar getBoundingClientRect com escrita de style
    // força o layout a ser recalculado no meio do loop.
    var fila = [];
    for (i = 0; i < scenes.length; i++) {
      var s = scenes[i];
      if (s.__slNear === false) continue;

      var r = s.getBoundingClientRect();
      // sem IntersectionObserver, cai no guard antigo
      if (!sceneIO && (r.bottom < -vh || r.top > vh * 2)) continue;

      fila.push(s, r);
    }

    // Fase 2 — só ESCRITA.
    for (i = 0; i < fila.length; i += 2) {
      var el = fila[i];
      var rect = fila[i + 1];

      var base = el.__slBase || 0;
      var p = clamp01((rawProgress(el, rect, vh, narrow) - base) / (1 - base));

      setP(el, ease(p).toFixed(4));
    }
  }

  function onScroll() {
    // Sem cena por perto não há nada a fazer — e é este teste que evita agendar
    // um rAF (com duas leituras de layout dentro) nas seis seções da LP que não
    // têm cena nenhuma.
    if (ticking || (sceneIO && ativas === 0)) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function onResize() {
    // a linha de base depende da altura da tela e da largura (a arte muda de
    // tamanho junto); recalcula só o que ainda não saiu do zero
    if (atTop()) setBaselines(true);
    onScroll();
  }

  var bound = false;

  function bindListeners() {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
    window.addEventListener('load', update);
  }

  function init() {
    collect();

    if (reduced) {
      for (var i = 0; i < scenes.length; i++) setP(scenes[i], '1');
      return;
    }

    // Registra antes de checar se há cena: a trava de boot é permanente, então
    // sair cedo aqui deixaria o motor morto para sempre numa página que ganhasse
    // uma cena depois (editor de temas).
    bindListeners();
    if (!scenes.length) return;

    // só remapeia quando a página abre no topo — recarregar no meio da LP
    // deve manter a cena no estado final, não reiniciar a animação
    if (atTop()) setBaselines(false);

    update();
  }

  // rolagem suave nos links internos da LP (âncoras #)
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-sl-scroll]') : null;
    if (!trigger) return;

    var href = trigger.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;

    var target = document.getElementById(href.slice(1));
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // editor de temas: a seção é re-renderizada e o elemento da cena é um nó NOVO
  document.addEventListener('shopify:section:load', function () {
    collect();
    bindListeners();
    if (atTop()) setBaselines(false);
    else restoreBaselines();
    update();
  });
  document.addEventListener('shopify:section:unload', function () {
    collect();
  });
})();
